<template>
  <v-row no-gutters class="mx-0">
    <TaskOutcomeDialog :selected-task="selectedTaskOutcomeTask"
                       :selected-user-id="selectedTaskOutcomeUserId"
                       @input="clearSelectedOutcomeTaskAndUserId()"
                       @getTasks="getTasks()"
                       v-model="isTaskOutcomeDialogVisible" />
    <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="$t('general.tasks')">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :color="mainColor"
                 fab
                 dark
                 depressed
                 :small="$vuetify.breakpoint.mdAndUp"
                 :x-small="$vuetify.breakpoint.smAndDown"
                 @click="toggleAddNewTaskComponent(!isAddNewTaskComponentShown)"
                 v-on="on">
            <v-icon>{{ isAddNewTaskComponentShown ? 'mdi-close' : 'mdi-plus' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ isAddNewTaskComponentShown ? $t('general.cancel') : $t('general.insertANewTask') }}</span>
      </v-tooltip>
    </ComponentsFixedBar>

    <template v-if="isAddNewTaskComponentShown">
      <v-col cols="12" class="pb-4" style="padding-top: 60px">
        <AddNewTask
          :main-color="mainColor"
          :types-of-task="typesOfTaskItems"
          :user-id="selectedUser.userId"
          :user-tasks="userTasks"
          @getTasks="getTasks()"
          @toggleAddNewTaskComponent="toggleAddNewTaskComponent(false)"
          @updateTypes="getTypeOfTasks"
        >
        </AddNewTask>
      </v-col>
    </template>

    <template v-else>
      <v-col cols="12"
             md="6"
             class="pb-4"
             :class="$vuetify.breakpoint.mdAndUp ? 'pr-3' : 'pr-0'"
             style="padding-top: 60px"
      >

        <TasksListGroup
          :all-tasks="userTasks"
          :main-color="mainColor"
          :tasks="classifiedTasks.undone"
          :is-task-done="false"
          :types-of-task="typesOfTaskItems"
          :userId="selectedUser.userId"
          @getTasks="getTasks()"
          @showTaskOutcomeDialog="showTaskOutcomeDialog"
        />
      </v-col>
      <v-col cols="12"
             md="6"
             class="pb-4"
             :class="$vuetify.breakpoint.mdAndUp ? 'pl-3' : 'pl-0'"
             :style="$vuetify.breakpoint.mdAndUp ? 'paddingTop: 60px' : null"
      >
        <TasksListGroup
          :all-tasks="userTasks"
          :main-color="mainColor"
          :tasks="classifiedTasks.done"
          :is-task-done="true"
          :types-of-task="typesOfTaskItems"
          :userId="selectedUser.userId"
          @getTasks="getTasks()"
          @showTaskOutcomeDialog="showTaskOutcomeDialog"
        />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapGetters, mapState } from 'vuex'
import AddNewTask from '@/pages/App/People/dialogs/ViewUser/Tasks/AddNewTask'
import TasksListGroup from '@/pages/App/People/dialogs/ViewUser/Tasks/TasksListGroup'
import TaskOutcomeDialog from '@/pages/App/Sequences/Tasks/TaskOutcomeDialog'
import TaskOutcomeMixin from '@/mixins/TaskOutcomeMixin'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
import usersTasksService from '@/services/usersTasksService'
export default {
  components: { ComponentsFixedBar, AddNewTask, TasksListGroup, TaskOutcomeDialog },
  computed: {
    ...mapGetters(['appUuid', 'companyUuid', 'userTasks']),
    ...mapState({
      selectedUser: state => state.users.selectedUser
    }),
    classifiedTasks () {
      if (this.userTasks.length === 0) return { done: [], undone: [] }
      const done = this.userTasks.filter(item => item.done)
      const undone = this.userTasks.filter(item => !item.done)
      return {
        done,
        undone
      }
    }
  },
  created () {
    this.getTasks()
    this.getTypeOfTasks()
  },
  data () {
    return {
      isAddNewTaskComponentShown: false,
      typesOfTaskItems: []
    }
  },
  methods: {
    async getTasks () {
      try {
        const { userId } = this.selectedUser
        await this.$store.dispatch('getUserTasks', {
          companyId: this.companyUuid,
          appId: this.appUuid,
          userId
        })
      } catch (e) {
        notifications.error(e)
        throw e
      }
    },
    async getTypeOfTasks () {
      try {
        const app = this.$store.getters.appUuid
        const company = this.$store.getters.companyUuid

        const response = await usersTasksService.getTypeOfTasks(company, app)
        this.typesOfTaskItems = response.rows
      } catch (e) {
        notifications.error(this.$t('general.errorLoadingTaskTypes'))
      }
    },
    toggleAddNewTaskComponent (value) {
      this.isAddNewTaskComponentShown = value
    }
  },
  mixins: [TaskOutcomeMixin],
  props: {
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    }
  }
}
</script>
